/**
 * ## Button list component
 *
 * @module src/components/buttonlist
*/

'use strict';

const destroy = () => {
    $('#component_catch').css('display', 'none');
};

/**
 * Button list display.
 */
const create = (options, data, callback) => {
    let drophtml = '';
    let dropcount = 0;
    data.forEach((row) => {
        if (options.highlight === row.value || options.highlight === row.description) {
            drophtml += `<div class="buttonlistitem theme_bg_carbon" \
                        id="bl${++dropcount}${options.target_id}" \
                        data-value="${row.value}" data-description="${row.description}">\
                        <i class="fa fa-check"></i> ${row.description}</div>`;
        } else {
            drophtml += `<div class="buttonlistitem" id="bl${++dropcount}${options.target_id}" \
                        data-value="${row.value}" data-description="${row.description}">\
                        ${row.description}</div>`;
        }
    });
    drophtml += '<div class="buttonlistend"></div>';
    $(`#${options.target_id}`).html(drophtml);
    $('.buttonlistitem').off();
    $('.buttonlistitem').fastClick((e) => {
        e.stopPropagation();
        e.preventDefault();
        destroy();
        const returned = {
            value: $(`#${e.target.id}`).data('value'),
            description: $(`#${e.target.id}`).data('description'),
        };
        callback(null, returned);
    });
};

module.exports = {
    create,
    destroy,
};



/** WEBPACK FOOTER **
 ** ./src/components/buttonlist/index.js
 **/